import React, { CSSProperties } from 'react'
import styled from 'styled-components'

import Theme from '../theme'
import { Business } from '../utils/constants'

const ContactLink = styled.a<CSSProperties>`
    color: ${props => props.color ? props.color : Theme.palette.primary.light};
    text-decoration: none;
    display: block;
    width: 100%;

    :hover {
        color: ${Theme.palette.primary.dark};
        text-decoration: none;
    }
`

const Icon = styled.i`
    font-size: 36px; 
    margin-right: 20px;
`

const SectionBlock = styled.div`
    display: flex;
    align-items: center;
    margin: 0;
    padding: 20px;
    align-items: center;
    overflow-wrap: break-word;
    word-break: break-word;
    hyphens: none;
`

const AddressLineWrapper = styled.div`
    display: flex; 
    flex-direction: column; 
    justify-content: left;
`

const AddressLine = styled.p`
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
`

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    max-width: 450px;
    margin: 0 auto;
`

const ContactInfo: React.SFC<{margin?: string, color?: string}> = props => {
    return(
        <Root>
            <ContactLink 
                href={`mailto:${Business.email}`}
                color={props.color ? props.color : ''}>
                <SectionBlock>
                    <Icon className="material-icons">email</Icon>
                    <p style={{ margin: 0 }}>{Business.email}</p>
                </SectionBlock>
            </ContactLink>
            <ContactLink 
                margin="20px 0"
                href={`tel:1${Business.phoneNumber}`}
                color={props.color ? props.color : ''}>
                <SectionBlock>
                    <Icon className="material-icons">phone</Icon>
                    <p style={{ margin: 0 }}>{Business.phoneNumber}</p>
                </SectionBlock>
            </ContactLink>
            <ContactLink 
                href="https://goo.gl/maps/8UUi1MLU1WN2" 
                target="_blank"
                color={props.color}>
                <SectionBlock>
                    <Icon className="material-icons">directions</Icon>
                    <AddressLineWrapper>
                        <AddressLine>201 NW Victoria Dr</AddressLine>
                        <AddressLine>Lees Summit, MO 64086 United States</AddressLine>
                    </AddressLineWrapper>
                </SectionBlock>
            </ContactLink>
        </Root>
    )
}

export default ContactInfo